import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputLabel, FormControl, withStyles } from 'material-ui';
import Dictionary from '../../../model/Dictionary';
import RelationshipDropdownContainerStyles from './RelationshipDropdownContainerStyles';
import RelationshipDropdown from './RelationshipDropdown';

class RelationshipDropdownContainer extends Component {
  static propTypes = {
    classes: PropTypes.object,
    relationshipType: PropTypes.string,
    selectRelationshipType: PropTypes.func,
  };

  render () {
    const { relationshipType, selectRelationshipType, classes } = this.props;

    return (
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor='select-multiple' className={classes.inputLabel}>
          {Dictionary.passengers.selectRelationship}
        </InputLabel>

        <RelationshipDropdown
          relationshipType={relationshipType}
          selectRelationshipType={selectRelationshipType}
        />
      </FormControl>
    );
  }
}

export default withStyles(RelationshipDropdownContainerStyles)(RelationshipDropdownContainer);



// WEBPACK FOOTER //
// ./src/components/passengers/relationshipDropdown/RelationshipDropdownContainer.js